import React, { ReactNode } from 'react';

interface CommunityHeaderProps {
  title?: string;
  action?: ReactNode;
}

export default function CommunityHeader({ title, action }: CommunityHeaderProps): JSX.Element {
  return (
    <div className="top-0">
      {/* Top Section with Title and Create */}
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-col gap-2">
          {title ? <h1 className="text-3xl font-bold text-primary">{title}</h1> : null}
        </div>

        <div className="flex w-full justify-start sm:w-auto sm:justify-end">
          {/* show create button if available */}
          {action && <div className="w-full sm:w-auto">{action}</div>}
        </div>
      </div>
    </div>
  );
}
